"use strict";
var Observable_1 = require('../../Observable');
var mergeMapTo_1 = require('../../operator/mergeMapTo');
Observable_1.Observable.prototype.flatMapTo = mergeMapTo_1.mergeMapTo;
Observable_1.Observable.prototype.mergeMapTo = mergeMapTo_1.mergeMapTo;
//# sourceMappingURL=mergeMapTo.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/rxjs/add/operator/mergeMapTo.js
 ** module id = 561
 ** module chunks = 2
 **/